import { Flex, Text, Loader as LoaderMantine } from '@mantine/core';
import React from 'react';

interface LoaderProps {
  message?: string;
}

const Loader: React.FC<LoaderProps> = ({ message = 'Loading...' }) => {
  return (
    <Flex justify={'center'} direction={'column'} align={'center'}>
      <LoaderMantine color="grape" />
      <Text fw={'bold'} fz={12}>
        {message}
      </Text>
    </Flex>
  );
};

export default Loader;
